import EditPaymentScene from './EditPaymentScene'
export default EditPaymentScene